import http from '@/$plugins/http'
import { STOREMODULE_ENDPOINTMODULE_MAP } from '@/constants'

export default {
  async getMailUnsubscribed (email) {
    const result = await http({
      method: 'get',
      url: `/${STOREMODULE_ENDPOINTMODULE_MAP.databridge}/api/mailunsubscribe/${email}`
    })

    if (result.data.success) {
      return result.data.result
    }
    console.log(result.data.errorMessage)
    return null
  },
  async getAllUnsubscribeMailTypes () {
    const result = await http({
      method: 'get',
      url: `/${STOREMODULE_ENDPOINTMODULE_MAP.databridge}/api/mailunsubscribe/mailtypes`
    })

    if (result.data.success) {
      return result.data.result
    }
    console.log(result.data.errorMessage)
    return null
  },
  async mailUnsubscribe (email, mailType) {
    const result = await http({
      method: 'post',
      url: `/${STOREMODULE_ENDPOINTMODULE_MAP.databridge}/api/mailunsubscribe/unsubscribe`,
      data: {
        email,
        mailType
      }
    })

    if (result.data.success) {
      return result.data.result
    }
    console.log(result.data.errorMessage)
    return null
  },
  async mailUnsubscribeRemove (email, mailType) {
    const result = await http({
      method: 'post',
      url: `/${STOREMODULE_ENDPOINTMODULE_MAP.databridge}/api/mailunsubscribe/unsubscribe/remove`,
      data: {
        email,
        mailType
      }
    })

    if (result.data.success) {
      return result.data.result
    }
    console.log(result.data.errorMessage)
    return null
  }
}
